module.exports = __webpack_public_path__ + "static/media/JosephAremu.3c18459b.jpeg";